import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Stack, Box, Radio } from '@mui/material'
import { LrModalUI } from '../../common/LrModalUI'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import DropDownOA from '../../common/dropDownOA'
import LineInput from '../../common/lineinput'
import { GetActivityUI } from '../../activity'
import { useSearchParams } from 'react-router-dom'
import { Item, SuccessPopUp } from '../../common/snippets'
import Datepicker from '../../common/datePicker'
import { updateStrtCity, updateBrnchList, updateStrtBrnch, getBranchList } from '../../../store/common/common_action'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { getUpdateReceiveDispatchCity } from '../../../store/branchTransferReceive/branchReceive_action'
import StatusLoaderModal, { clickElement, focusElemnt, isEmpty, removeDuplicatesFromArray } from '../../common/helper'
import {
  Receieve_Receiving_Branch,
  Receieve_Select_Challan,
  Receive_Consignment_Type,
  Receive_Dispatch_From_Branch,
  Receive_Dispatch_From_City,
  Receive_Receiving_City,
  Receive_Select_Vehicle,
} from '../BranchTransferReceive/Lables'
import Modal from '../../common/modal'
import { API_CACHE_DURATION, Consignmentobj, branchObj, urls } from '../../common/constants'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useAtom, useSetAtom } from 'jotai'
import { GetRequest, PostRequest, PostRequestCachedV3 } from '../../common/api'
import {
  ChallanListAtom,
  LITReceiveAtom,
  receiveLITLrListAtom,
  receiveLrListAtom,
  selectChallanAtom,
  showListAllAtom,
} from '../../common/jotaiState/receiveStateAtoms'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import dayjs from 'dayjs'
import LoaderModel from './loaderModel'
import DropDownMultiSelectV2 from '../../common/dropDownMultiSelectV2'
import { getBranches } from '../BookingActivity/apiCalls'
import { GT_COMPANY_ID, GUJRAT_COMPANY_ID } from '../../../helper/companyIdhardcode'
import useToken from '../../helpers/useTokens'

const TopSection = ({
  data,
  buttonId,
  setState,
  updateStrtCity,
  updateBrnchList,
  updateStrtBrnch,
  getUpdateReceiveDispatchCity,
  getBranchList,

  topSelectedData,
  setTopSelectedData,
  tSecDropData,
  setTSecDropData,
  setShowBtnList,
  showBtnList,
}) => {
  const [searchParams] = useSearchParams()
  const setLoader = useSetAtom(globalLoaderAtom)
  const [, setAlert] = useAtom(alertAtom)
  const { common, BranchTransferReceiveReducer } = data
  const { strtCity, strtBrnch, cityList, brnchList, destCity, strtBrnchList, cnsgnmntTypes } = { ...common }
  const { receiveDispatchCities } = { ...BranchTransferReceiveReducer }

  const [companySettings] = useAtom(companySettingsAtom)
  const { loginData } = useToken()
  const { intCompanyID } = loginData
  const { UseToPayAsCOD } = companySettings
  const currentView = searchParams.get('view') || common.selectedActvty
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const [LITReceive, setLITReceive] = useAtom(LITReceiveAtom)
  const [dispatchFromCityList, setDispatchFromCityList] = useState([])
  const { Table1 = [] } = roleRights
  const [cargoRights = {}] = Table1
  const { AllowLitReceive } = cargoRights
  const [modal, setModal] = useAtom(modalAtom)
  const [apiData, setApiData] = useState({
    senCNnST: '',
    isScUpdated: false,
  })
  const [dispatchBranch, setDispatchBranch] = useState()
  const { isScUpdated } = apiData
  const [activeClass, setActiveClass] = useState({
    VehicleWise: false,
    ChallanWise: false,
    bkButton: false,
  })
  const { VehicleWise, ChallanWise } = activeClass
  const [dataState, setDataState] = useState({
    selectGoDisable: false,
    GoBtnDes: true,
    toDayDate: '',
    loadVehicle: false,
  })
  const [vehicleList, setVehicleList] = useState([])
  const [vehicleList1, setVehicleList1] = useState([])
  const [, setReceiveLrList] = useAtom(receiveLrListAtom)
  const [, setReceiveLITLrList] = useAtom(receiveLITLrListAtom)
  const [challanList, setChallanList] = useAtom(ChallanListAtom)
  const [challanListData, setChallanListData] = useState([])
  const [selectedChallan, setSelectedChallan] = useAtom(selectChallanAtom)
  const [, setShowListAll] = useAtom(showListAllAtom)
  const [litLRList, setLitLRList] = useState([])
  const { selectGoDisable, GoBtnDes, loadVehicle, toDayDate } = dataState
  const [branchStatusList, setBranchStatusList] = useState([])
  const [vehicleStatusList, setVehicleStatusList] = useState([])
  useEffect(() => {
    if (LITReceive !== 2) {
      setTopSelectedData({ ...topSelectedData, LRNO: '' })
    }
  }, [LITReceive])
  function dateFormat(inputDate, format) {
    //parse the input date
    const date = new Date(inputDate)

    //extract the parts of the date
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    //replace the month
    format = format.replace('MM', month.toString().padStart(2, '0'))

    //replace the year
    if (format.indexOf('yyyy') > -1) {
      format = format.replace('yyyy', year.toString())
    } else if (format.indexOf('yy') > -1) {
      format = format.replace('yy', year.toString().substr(2, 2))
    }

    //replace the day
    format = format.replace('dd', day.toString().padStart(2, '0'))

    return format
  }

  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }
  // All UseEffect

  const getDispatchFromCityList = () => {
    setLoader(true)
    const data = {
      intCompanyID: loginData.intCompanyID,
      intUserID: loginData.intUserID,
      intBranchID: strtBrnch?.BranchID,
    }
    PostRequestCachedV3(urls.getReceiveDispatchCitiesBranches, data, true, API_CACHE_DURATION)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error("No Data Found")
        }
        const data = res.cities.map((city) => ({
          ...city,
          CityID: city.FromCityID,
          CityName: city.FromCity,
          BranchID: city.FromBranchId,
          BranchName: city.FromBranch,
        }))
        setDispatchFromCityList(data)
      })
      .catch((err) => {
        setDispatchFromCityList([])
        setAlert({ show: true, msg: err.message || 'Something went wrong', nextId: '' })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  useEffect(() => {
    setActiveClass({ ...activeClass, VehicleWise: true })
  }, [])

  useEffect(() => {
    const todayDate = new Date().toString().split(' ')
    const year = todayDate[3]
    const day = todayDate[2]
    const month = getNumericMonth(todayDate[1])
    const currentDate = `${year}-${month}-${day}`
    setDataState({ ...dataState, toDayDate: currentDate })
    focusElemnt('Receive_Dispatch_From_City')
  }, [])

  useEffect(() => {
    if (!isEmpty(loginData) && !isEmpty(strtBrnch)) {
      getDispatchFromCityList()
    }
  }, [strtCity, strtBrnch])
  // For Str city abd Branch
  useEffect(() => {
    if (cityList.length > 0) {
      const sC = cityList?.find(({ CityID }) => CityID == loginData.intBranchCityID)
      if (sC) {
        updateStrtCity(sC)
        if (!isScUpdated) {
          setApiData({ ...apiData, senCNnST: destCity.CityName + `, ${destCity.StateName}`, isScUpdated: true })
        }
        setApiData({ ...apiData, senCNnST: sC.CityName + `, ${sC.StateName}` })
      }
    }
  }, [cityList])

  useEffect(() => {
    if (brnchList.length > 0) {
      updateStrtBrnch(brnchList.find(({ BranchID }) => BranchID == loginData.intBranchID) || {})
      updateBrnchList(brnchList, 1)
    }
  }, [brnchList])
  const getVehicleListByBranch = async (branchList = [], dispatchBranch) => {
    if (ChallanWise) {
      const fromCityIds = branchList.map((item) => item.CityID).join('^')
      const fromBranchIds = branchList.map((item) => item.BranchID).join('^')
      const data = {
        intCompanyID: loginData.intCompanyID,
        intFromCityID: topSelectedData?.DFromCity?.CityID,
        intToCityID: strtCity.CityID,
        dtJdate: toDayDate,
        intVehicleID: 0,
        intCurrentBranch: strtBrnch.BranchID,
        intMode: 0,
        FromBranchIDs: fromBranchIds,
        FromCityIDs: fromCityIds,
      }
      getUpdateReceiveChallanNo(data)
      return
    }
    const statusInit = branchList.map((val) => ({
      loaded: 0,
      data: [],
      BranchID: val.BranchID,
      BranchName: val.BranchName,
      CityID: val.CityID,
    }))
    setVehicleStatusList(statusInit)
    const basePayload = {
      intCompanyID: loginData.intCompanyID,
      intToCityID: strtCity.CityID,
      dtJdate: toDayDate,
      intMode: 6,
      intToBranchID: loginData.intBranchID || 0,
    }
    const vehicleDataList = []
    if (branchList.length === dispatchBranch.length && loginData.intCompanyID === GT_COMPANY_ID) {
      const res = await getVehicleList({ ...basePayload, intFromCityID: 0, intFromBranchID: 0 })
      vehicleDataList.push(...res)
    } else {
      setModal('VehicleloaderModal')
      for (const branch of branchList) {
        const { BranchID, CityID } = branch
        setVehicleStatusList((prev) => prev.map((item) => (item.BranchID === BranchID ? { ...item, loaded: 1 } : item)))
        const res = await getVehicleList({ ...basePayload, intFromCityID: CityID, intFromBranchID: BranchID })
        vehicleDataList.push(...res.map((item) => ({ ...item, BranchID, CityID })))
        setVehicleStatusList((prev) => prev.map((item) => (item.BranchID === BranchID ? { ...item, loaded: 2 } : item)))
      }
      setModal(null)
    }
    setVehicleList1(vehicleDataList)
    setVehicleList(removeDuplicatesFromArray(vehicleDataList, 'VehicleNo'))
    clickElement('receiveVehicle')
  }
  const saveCtyInSession = (city) => {
    setTopSelectedData({ ...topSelectedData, DFromCity: city, resetData: false })
    const selectedCityIds = city.map((c) => c.CityID)
    const filterBranches = dispatchFromCityList?.filter((val) => selectedCityIds.includes(val.CityID))
    if (intCompanyID === GUJRAT_COMPANY_ID && filterBranches.length > 1) {
      setDispatchBranch([{ BranchID: 0, BranchName: 'All Branches', CityID: 0 }, ...filterBranches])
    } else {
      setDispatchBranch(filterBranches)
    }
  }
  // getBranchListData(filterBranches)
  // sessionStorage.setItem('receiveCity', JSON.stringify(city))
  //All useEffetct End
  const onKeyDown = (e, id) => {
    if (e.key === 'Escape') {
      switch (id) {
        case 'firstGo':
          focusElemnt('ReceiveDispatchBranchName')
          break
        case 'showlist':
          focusElemnt(Receive_Consignment_Type)
          break
        case 'secondGo':
          focusElemnt('receiveVehicle')
          break
        default:
          break
      }
    } else if (e.key === 'Enter') {
      // setState({ showListTable: true })
      switch (id) {
        case 'showlist':
          focusElemnt('checkbox_0')
          break
        default:
          break
      }
    }
  }
  const ButtonClick = (id) => {
    switch (id) {
      case 'Vehicle':
        setActiveClass({ ...activeClass, VehicleWise: true, ChallanWise: false })
        setDataState({ ...dataState, selectGoDisable: false })
        setShowBtnList(true)
        setChallanList([])
        setSelectedChallan({})
        break
      case 'Challan':
        setActiveClass({ ...activeClass, VehicleWise: false, ChallanWise: true, bkButton: false })
        setDataState({ ...dataState, selectGoDisable: true })
        setChallanList([])
        setSelectedChallan({})
        if (GoBtnDes == false) {
          setShowBtnList(false)
        }
        break
      case 'LITVehicle':
        setLITReceive(1)
        break
      case 'LITLR':
        setLITReceive(2)
        break
      default:
        break
    }
  }
  const getVehicleList = (data) => {
    return PostRequest(urls.getVehilceList, data).then((res) => {
      if (res?.status !== 'Success') {
        return []
      }
      if (!Array.isArray(res.Data) || res.Data.length === 0) {
        return []
      }
      return res.Data
    })
  }
  const getUpdateReceiveSHowListData = (data) => {
    return PostRequest(urls.getReceiveShowlistData, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data) || res.Data.length === 0) {
          throw new Error('No Data Found')
        }
        const modifiedData = res.Data.map((item) => ({
          ...item,
          PaymentType: !UseToPayAsCOD
            ? item.PaymentType
            : item.PaymentType === 'TO PAY'
              ? 'COD'
              : item.PaymentType === 'TO PAY Manual'
                ? 'COD MANUAL'
                : item.PaymentType === 'TO PAY DDDV'
                  ? 'COD(DDDV)'
                  : item.PaymentType,
        }))
        return modifiedData
      })
      .catch((err) => {
        throw err
      })
  }
  const getLITLrList = async () => {
    let strLRNO = ''
    if (topSelectedData.LRNO.includes('/') || topSelectedData.LRNO.includes('\\')) {
      strLRNO = topSelectedData.LRNO
    } else {
      strLRNO = '0000000' + topSelectedData.LRNO
      strLRNO = strLRNO.substring(strLRNO.length - 7)
    }
    const data = {
      strLRNO: strLRNO,
      intCompanyID: loginData.intCompanyID,
      intBranchID: strtBrnch.BranchID,
      intUserID: loginData.intUserID,
      intBranchCityID: strtCity.CityID,
      intChallanNo: 0,
      intLrShowMode: 5,
      intBookingID: 0,
      intisCurrentYear: 0,
    }
    GetRequest(urls.GetLRDetailsForPopUpV2, data)
      .then((res) => {
        if (res.status === 'Success') {
          const list = res?.Data?.table || []
          if (list.length > 0) {
            setLitLRList(
              list.map((item) => ({
                ...item,
                BookingDateTime: dayjs(item.BookingDateTime, 'YYYY-MM-DD hh:mm A').format('DD-MM-YYYY HH:mm'),
              }))
            )
            setModal('LRNoList')
          } else {
            setAlert({ show: true, msg: 'No Data Found', nextId: '' })
          }
        }
      })
      .catch((err) => {})
  }
  const getUpdateReceiveChallanNo = (data) => {
    setLoader(true)
    PostRequest(urls.getReceiveDispatchChallanNo, data)
      .then((res) => {
        if (res.status !== 'Success' || !Array.isArray(res.Data)) {
          throw new Error(res?.ErrMessage || 'Invalid Response')
        }
        if (!res.Data.length) {
          throw new Error('No Data Found')
        }
        if (res.Data.length > 1) {
          res.Data.unshift({ VoucherNo: 'All' })
        }
        setChallanList(res.Data.sort((a, b) => a.VoucherNo - b.VoucherNo))
        setSelectedChallan(res.Data[0])
      })
      .catch((err) => {
        setChallanList([])
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => {
        setLoader(false)
      })
  }
  const buttonClick = (id, SelectedVehicle) => {
    switch (id) {
      case 'firstGo':
        setShowBtnList(false)
        getVehicleListByBranch(topSelectedData?.DFromBranch, dispatchBranch)
        setLITReceive(0)
        break
      case 'SecondGo':
        if (LITReceive === 1) {
          setShowBtnList(false)
          focusElemnt('receiveShowList')
          return
        }
        const data = SelectedVehicle.map((item) => item.VehicleWithDetail)
        const challanList = vehicleList1.filter((item) => data.includes(item.VehicleWithDetail)).sort((a, b) => a.VoucherNo - b.VoucherNo)
        if (challanList.length > 1) {
          challanList.unshift({ VoucherNo: 'All' })
        }
        setChallanList(challanList)
        setSelectedChallan(challanList?.[0] || {})
        setDataState({ ...dataState, GoBtnDes: false })
        clickElement('receiveVoucherNos')
        setShowBtnList(false)
        break
      case 'Load':
        if (LITReceive === 1) {
          setModal('LITConfirmationPopup')
        } else {
          if (topSelectedData.LRNO === '') {
            setAlert({ show: true, msg: 'Fill The LR Number', nextId: '' })
          } else {
            getLITLrList()
          }
        }
        break
      default:
        break
    }
  }
  const CofnrimationPopup = () => {
    const data = {
      successMessage: 'Load all vehicle list not dispatched to your branch?',
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesDefault: true,
      yesAction: async () => {
        const loadObj = {
          intCompanyID: loginData.intCompanyID,
          intFromCityID: 0,
          intToCityID: 0,
          dtJdate: toDayDate,
          intMode: 900,
          intFromBranchID: 0,
          intToBranchID: loginData.intBranchID,
          ToCityIDs: '',
          ToBranchIDs: '',
        }
        setLoader(true)
        PostRequest(urls.getVehilceList, loadObj)
          .then((res) => {
            if (res?.status !== 'Success') {
              throw new Error('Failed to load vehicle list')
            }
            if (!Array.isArray(res.Data) || res.Data.length === 0) {
              throw new Error('No vehicle data available')
            }
            setVehicleList(res.Data)
            setVehicleList1(res.Data)
            setDataState((prev) => ({ ...prev, loadVehicle: true }))
          })
          .catch((err) => {
            setAlert({ show: true, msg: err.message, nextId: '' })
            setVehicleList([])
            setVehicleList1([])
          })
          .finally(() => {
            setLoader(false)
            setModal('')
          })
      },
      noAction: () => {
        setModal('')
      },
    }
    return <SuccessPopUp data={data} updateModal={setModal} />
  }
  const LrPopup = () => {
    return (
      <Modal headTxt={`List of LR for LIT Receive`} width={'95%'} updateModal={setModal}>
        <LrModalUI dataList={litLRList} />
      </Modal>
    )
  }
  const showListButton = async (showListAll, vehicleList) => {
    if (LITReceive === 1) {
      const selectVehicle = vehicleList || topSelectedData.SelectedVehicle
      const date = selectVehicle[0]?.VehicleWithDetail?.split(':')[1].trim()
      const data = {
        intBookingID: 0,
        intCityID: loginData.intBranchCityID,
        intBranchID: loginData.intBranchID,
        intCompanyID: loginData.intCompanyID,
        intMode: 3,
        strVehicleNo: selectVehicle[0]?.VehicleNo,
        intVehicleID: selectVehicle[0]?.VehicleID,
        intUserID: loginData.intUserID,
        Date: dayjs(date).format('YYYY-MM-DD'),
      }
      setReceiveLrList([])
      GetRequest(urls.getReceiveLuggageToReceive, data)
        .then((res) => {
          if (res.status === 'Success') {
            setReceiveLITLrList(res.Data)
          } else {
            setReceiveLITLrList([])
          }
        })
        .catch((err) => {})
    } else {
      setReceiveLITLrList([])
      if (VehicleWise === true && topSelectedData.SelectedVehicle.length === 0) {
        setAlert({ show: true, msg: 'Select Vehicle', nextId: '' })
        return
      }
      if (ChallanWise && !selectedChallan?.length) {
        setAlert({ show: true, msg: 'Select Challan Number', nextId: '' })
        return
      }
      const vehicleDate = VehicleWise ? topSelectedData?.SelectedVehicle[0]?.VehicleWithDetail?.split(':') : toDayDate
      const dtDate = VehicleWise ? dateFormat(vehicleDate[1].split('-'), 'yyyy-MM-dd') : toDayDate
      const object = {
        intCompanyID: loginData.intCompanyID,
        intUserID: loginData.intUserID,
        intToCityID: strtCity.CityID,
        intToBranchID: strtBrnch.BranchID,
        dtDate: dtDate,
        intConsignmentType: tSecDropData.selectconsignmentType === 'All' ? 0 : tSecDropData.selectconsignmentType.ConsignmentSubTypeID,
      }
      const data = selectedChallan[0]?.VoucherNo === 'All' ? challanList.slice(1) : selectedChallan
      // if (data.length > 1) {
      setChallanListData(
        data.map((item) => ({
          loaded: 0,
          VoucherNo: item.VoucherNo,
        }))
      )
      setModal('loaderModal')
      const receiveLrList = []
      for (let i = 0; i < data.length; i++) {
        const VoucherNo = data[i].VoucherNo
        const VehicleNo = data[i].VehicleNo
        const CityID = data[i].CityID
        const BranchID = data[i].BranchID
        const VehicleID = data[i].VehicleID
        setChallanListData((prevList) => prevList.map((item) => (item.VoucherNo === VoucherNo ? { ...item, loaded: 1 } : item)))
        let res = []
        try {
          res = await getUpdateReceiveSHowListData({
            ...object,
            intVoucherNo: VoucherNo,
            strVehicleNo: VehicleNo,
            intFromCityID: CityID,
            intFromBranchID: BranchID,
            intVehicleID: VehicleID,
          })
        } catch (err) {
          res = []
        }
        setChallanListData((prevList) => prevList.map((item) => (item.VoucherNo === VoucherNo ? { ...item, loaded: 2 } : item)))
        receiveLrList.push(...res.map((item) => ({ ...item, VehicleID, VehicleNo })))
      }
      setReceiveLrList(receiveLrList)
      setState({ showListTable: true })
      setShowListAll(showListAll)
      setModal('')
      // }
      // else {
      //   setLoader(true)
      //   getUpdateReceiveSHowListData(object)
      //     .then((res) => {
      //       setReceiveLrList(res)
      //       setState({ showListTable: true })
      //       setShowListAll(showListAll)
      //     })
      //     .catch((err) => {
      //       setReceiveLrList([])
      //       setAlert({ show: true, msg: err.message || 'No Data Found', nextId: '' })
      //     })
      //     .finally(() => {
      //       setLoader(false)
      //     })
      // }
    }
  }
  const getFromCityList = () => {
    let cityList = []

    if (dispatchFromCityList && dispatchFromCityList.length > 0) {
      cityList = removeDuplicatesFromArray(dispatchFromCityList, 'CityID')
      cityList = cityList.filter((val) => val.CityID !== strtCity.CityID)
    }
    if (intCompanyID === GUJRAT_COMPANY_ID && cityList.length > 1) {
      cityList = [{ CityID: 0, CityName: 'All Cities' }, ...cityList]
    }
    return cityList
  }

  return (
    <>
      <Stack
        direction="row"
        divider={
          <Divider
            orientation="vertical"
            sx={{
              width: '2px',
              margin: '14px -16px 0px 0px !important',
              backgroundColor: '#0086ff',
            }}
            flexItem
          />
        }
        spacing={2}
        sx={{ background: '#FFF' }}
      >
        <Item sx={{ width: '100%', paddingBottom: '0px', paddingTop: '16px' }}>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            {GetActivityUI(currentView)}
            <Item sx={{ width: '100%' }}>
              <DropDownMultiSelectV2
                type={Receive_Dispatch_From_City}
                data={getFromCityList() || []}
                width="100%"
                searchPlaceholder={`Search ${Receive_Dispatch_From_City}`}
                label={Receive_Dispatch_From_City}
                tabIndex="2"
                limit={32}
                selectionLabel={'Multiple Cities'}
                defaultvalue={topSelectedData.DFromCity || ''}
                setAllValue={setTopSelectedData}
                allValues={topSelectedData}
                dataKey={`CityName`}
                idKey={`CityID`}
                HasAllSelect={intCompanyID === GUJRAT_COMPANY_ID}
                crossIconId={'BranchReceiveFromCity'}
                id={'Receive_Dispatch_From_City'}
                prevId="activitytype"
                nextId="ReceiveDispatchBranchName"
                onSelect={(item) => saveCtyInSession(item)}
                // prevId={buttonId}
              />
            </Item>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '50%' }}>
              <div className="input--container date-picker" style={{ width: '100%' }}>
                <Datepicker
                  className="deliver-date-picker"
                  name={'filter_from_dt'}
                  type="filter_from_dt"
                  statusChecked={true}
                  label="Receive Date"
                  disabled
                />
              </div>
            </Item>
            <Item sx={{ width: '50%', paddingBottom: '0px', display: 'flex' }}>
              <DropDownMultiSelectV2
                type={Receive_Dispatch_From_Branch}
                label={Receive_Dispatch_From_Branch}
                data={topSelectedData.resetData ? [] : dispatchBranch || []}
                width="100%"
                searchPlaceholder={`Search Branch Name`}
                isObjArr={true}
                dataKey="BranchName"
                limit={32}
                idKey="BranchID"
                id="ReceiveDispatchBranchName"
                nextId="firstGoButtonReceive"
                prevId="Receive_Dispatch_From_City"
                setAllValue={setTopSelectedData}
                allValues={topSelectedData}
                HasAllSelect={intCompanyID === GUJRAT_COMPANY_ID}
                crossIconId="BranchReceiveFromBranch"
                defaultvalue={topSelectedData.DFromBranch || ''}
                onSelect={(branches) => {
                  setTopSelectedData((prev) => ({
                    ...prev,
                    DFromBranch: branches,
                  }))
                  //getVehicleListByBranch(branches, dispatchBranch)
                }}
              />
              <Button
                variant="contained"
                id="firstGoButtonReceive"
                disabled={topSelectedData.DFromBranch == null ? true : false}
                style={{
                  width: '10%',
                  height: '37px',
                  marginLeft: '7px',
                  backgroundColor: topSelectedData.DFromBranch == null ? '#cccccc' : '#ff0000',
                  // backgroundColor: '#ff0000',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={() => buttonClick('firstGo')}
                onKeyDown={(e) => onKeyDown(e, 'firstGo')}
              >
                GO
              </Button>
            </Item>

            <Item
              sx={{
                width: '50px',
                display: 'inline-flex',
                padding: '0% 5px',
                height: '50px',
                marginLeft: '-48px !Important',
                marginRight: '0px !Important',
              }}
            >
              <div
                style={{
                  position: 'relative',
                  top: '4px',
                  left: '45px',
                  border: '3px solid white',
                  height: '40px',
                  width: '40px',
                  background: '#0086ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  color: 'white',
                }}
              >
                <ArrowForwardIcon />
              </div>
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '25%' }}>
              <Button
                id={buttonId}
                sx={{
                  justifyContent: 'start',
                  border: VehicleWise ? '2px solid #0086ff' : '1px solid grey',
                  cursor: 'pointer',
                  width: '100%',
                }}
                autoFocus={true}
                onClick={() => ButtonClick('Vehicle')}
              >
                <LineInput type="radio" checked={VehicleWise} autoFocus={VehicleWise} />

                <span
                  style={{
                    fontSize: '14px',
                    paddingLeft: '8px',
                    fontWeight: '500',
                    color: 'black',
                    border: '0px',
                    textTransform: 'none',
                  }}
                >
                  Vehicle Wise
                </span>
              </Button>
            </Item>
            <Item sx={{ width: '25%' }}>
              <Button
                id={buttonId}
                sx={{
                  justifyContent: 'start',
                  border: ChallanWise ? '2px solid #0086ff' : '1px solid grey',
                  cursor: 'pointer',
                  width: '100%',
                }}
                // autoFocus={true}
                onClick={() => ButtonClick('Challan')}
              >
                <LineInput type="radio" checked={ChallanWise} />

                <span
                  style={{
                    fontSize: '14px',
                    paddingLeft: '8px',
                    fontWeight: '500',
                    color: 'black',
                    border: '0px',
                    textTransform: 'none',
                  }}
                >
                  Challan Wise
                </span>
              </Button>
            </Item>
            <Item sx={{ width: '50%', paddingBottom: '0px', display: 'flex' }}>
              <DropDownMultiSelectV2
                type={'set_default'}
                label={Receive_Select_Vehicle}
                data={topSelectedData.resetData ? [] : vehicleList || []}
                width="100%"
                searchPlaceholder={`Search Vehicle Number`}
                isObjArr={true}
                dataKey={`VehicleWithDetail`}
                idKey={`VehicleWithDetail`}
                id="receiveVehicle"
                limit={LITReceive === 1 ? 1 : 32}
                crossIconId={'BranchreceiveVehicleCross'}
                disabled={selectGoDisable}
                defaultvalue={topSelectedData.SelectedVehicle?.VehicleWithDetail || ''}
                prevId="firstGoButtonReceive"
                onSelect={(val) => {
                  setTopSelectedData({ ...topSelectedData, SelectedVehicle: val })
                  if (LITReceive === 1) {
                    showListButton(false, val)
                  }
                  if (LITReceive === 0) {
                    buttonClick('SecondGo', val)
                  }
                }}
              />
              <Button
                variant="contained"
                disabled={selectGoDisable || topSelectedData.SelectedVehicle === '' ? true : false}
                id="secondGoButtonReceive"
                style={{
                  width: '10%',
                  height: '37px',
                  marginLeft: '7px',
                  backgroundColor: selectGoDisable || topSelectedData.SelectedVehicle === '' ? '#cccccc' : '#ff0000',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={() => buttonClick('SecondGo', topSelectedData.SelectedVehicle)}
                onKeyDown={(e) => onKeyDown(e, 'secondGo')}
              >
                GO
              </Button>
            </Item>
          </Box>
        </Item>
        <Item sx={{ width: '100%', paddingBottom: '0px', paddingTop: '16px' }}>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                type={Receive_Receiving_City}
                defaultvalue={strtCity.CityName || ''}
                data={cityList || []}
                width="100%"
                searchPlaceholder={`Search ${Receive_Receiving_City}`}
                label={Receive_Receiving_City}
                disabled
                tabIndex="2"
                // typeOf={1}
                // isObjArr = {true}
                // dataKey = {`CityName`}
                // idKey = {`CityID`}
              />
            </Item>
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                id={Receive_Consignment_Type}
                nextId="receiveShowList"
                prevId="receiveVoucherNos"
                type={Receive_Consignment_Type}
                // defaultvalue={}
                defaultvalue={topSelectedData.resetData ? 'All' : 'All'}
                // defaultvalue={'All'}
                // data={cnsgnmntTypes || []}
                data={[Consignmentobj, ...cnsgnmntTypes] || []}
                width="100%"
                searchPlaceholder={`Search ${Receive_Consignment_Type}`}
                label={Receive_Consignment_Type}
                portal={true}
                isObjArr={true}
                dataKey={`SubType`}
                idKey={`ConsignmentSubTypeID`}
                setAllValue={setTSecDropData}
                allValues={tSecDropData}
              />
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
              flexBasis: 2,
            }}
          >
            <Item sx={{ flex: 1, paddingBottom: '0px' }}>
              <DropDownOA
                type={Receieve_Receiving_Branch}
                defaultvalue={strtBrnch.BranchName || ''}
                width="100%"
                searchPlaceholder={`Search ${Receieve_Receiving_Branch}`}
                label={Receieve_Receiving_Branch}
                disabled
              />
            </Item>
            <Item sx={{ flex: 1, display: 'flex', flexBasis: 22, gap: '8px' }}>
              <Button
                id={buttonId}
                style={{
                  justifyContent: 'start',
                  border: LITReceive === 1 ? '2px solid #0086ff' : '1px solid grey',
                  cursor: 'pointer',
                  padding: '0px 5px',
                  height: '39px',
                  flex: 5,
                }}
                onClick={() => ButtonClick('LITVehicle')}
                disabled={!AllowLitReceive}
              >
                <Radio style={{ padding: '0' }} checked={LITReceive === 1} disabled={!AllowLitReceive} />
                <span
                  // id={buttonId}
                  style={{
                    fontSize: '9px',
                    fontWeight: '900',
                    color: 'black',
                    paddingLeft: '5px',
                    textAlign: 'left',
                  }}
                >
                  LIT Vehicle
                </span>
              </Button>
              <Button
                id={buttonId}
                style={{
                  justifyContent: 'start',
                  border: LITReceive === 2 ? '2px solid #0086ff' : '1px solid grey',
                  cursor: 'pointer',
                  padding: '0px 5px',
                  height: '39px',
                  minWidth: '40px',
                }}
                onClick={() => ButtonClick('LITLR')}
                disabled={!AllowLitReceive}
              >
                <Radio style={{ padding: '0' }} checked={LITReceive === 2} disabled={!AllowLitReceive} />
                <span
                  style={{
                    fontSize: '9px',
                    fontWeight: '900',
                    color: 'black',
                    width: '20px',
                    textAlign: 'left',
                    marginLeft: '5px',
                  }}
                >
                  LIT LR
                </span>
              </Button>
              <div className={'input--wrapper'} style={{ marginBottom: 0, flex: 10 }}>
                <LineInput
                  id="LITLRNO"
                  type="text"
                  name={'LITLRNO'}
                  // label={`Remarks`}
                  value={topSelectedData.LRNO}
                  // onKeyDown={(e) => onKeyDown('remarks', e)}
                  onChange={(e) => setTopSelectedData({ ...topSelectedData, LRNO: e.target.value })}
                  disabled={LITReceive === 2 || !AllowLitReceive ? false : true}
                />
              </div>
              <Button
                onClick={(e) => buttonClick('Load', e)}
                variant="contained"
                style={{
                  backgroundColor: !AllowLitReceive ? '#cccccc' : '#fe5200',
                  height: '39px',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                  flex: 2,
                  minWidth: '50px',
                }}
                // onKeyDown={(e) => onKeyDownn(e)}
                // disabled={showBtnList}
                disabled={!AllowLitReceive ? true : false}
              >
                Load
              </Button>
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '100%', paddingBottom: '0px' }}>
              <DropDownMultiSelectV2
                type={'set_default'}
                defaultvalue={selectedChallan || []}
                data={challanList}
                width="100%"
                searchPlaceholder={`Search ${Receieve_Select_Challan}`}
                label={Receieve_Select_Challan}
                dataKey={`VoucherNo`}
                idKey={`VoucherNo`}
                id="receiveVoucherNos"
                onSelect={(e) => setSelectedChallan(e)}
                nextId={Receive_Consignment_Type}
                prevId="secondGoButtonReceive"
                disabled={[1, 2].includes(LITReceive)}
              />
            </Item>

            <Item sx={{ width: '100%', display: 'flex' }}>
              <Button
                variant="contained"
                id="receiveShowList"
                sx={{ width: '50%', marginRight: '5px' }}
                style={{
                  backgroundColor: showBtnList == true ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={() => showListButton(false)}
                onKeyDown={(e) => onKeyDown(e, 'showlist')}
                disabled={showBtnList}
              >
                SHOW LIST
              </Button>
              <Button
                variant="contained"
                sx={{ width: '50%', marginLeft: '5px' }}
                style={{
                  backgroundColor: showBtnList == true || loadVehicle == true ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                // disabled={true}
                disabled={loadVehicle || showBtnList}
                onClick={() => showListButton(true)}
              >
                SHOW LIST ALL
              </Button>
            </Item>
          </Box>
        </Item>
      </Stack>
      {modal === 'LRNoList' ? <LrPopup /> : <></>}
      {modal === 'loaderModal' && <LoaderModel list={challanListData} />}
      {modal === 'LITConfirmationPopup' && <CofnrimationPopup />}
      {modal === 'CommonloaderModal' && (
        <StatusLoaderModal
          modalKey="CommonloaderModal"
          title="Loading Userwise Collection for all Users"
          list={branchStatusList}
          labelKey="CityName" // or VoucherNo etc.
          statusKey="loaded"
        />
      )}
      {modal === 'VehicleloaderModal' && (
        <StatusLoaderModal
          modalKey="VehicleloaderModal"
          title="Loading Vehicles Branch Wise"
          list={vehicleStatusList}
          labelKey="BranchName"
          statusKey="loaded"
        />
      )}
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateStrtCity,
  updateBrnchList,
  updateStrtBrnch,
  getBranchList,
  getUpdateReceiveDispatchCity,
}

export default connect(mapStateToProps, mapDispatchToProps)(TopSection)
